import React from "react";
import DefaultButton from "../../../components/DefaultButton";
import { Link } from "react-router-dom";

export default function HumanDiscuss({data}){
  return(
    <>
      <section className={`sustaindiscuss-area human-discuss-area ${data?.newClass}`}>
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="sustaindiscuss-mainbox human-discuss-mainbox">
                <div className="row justify-content-center">
                  <div className="col-lg-9 text-center">
                    <h4 className="heading">{data?.head}</h4>
                    <span> {data?.desc}  <Link to={`tel:${data?.number}`}>  {data?.number} </Link></span>
                    <DefaultButton text={data?.btn} to={data?.slug} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}